export default "__VITE_ASSET__DCrzq7mM__"